import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './config/router'
import http from './utils/http'
import Components from './components/index';
import store from './config/store';
import mixin from './utils/mixin'
import * as filters from './filters'
import uploader from "vue-simple-uploader";

import i18n from './lang'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.mixin(mixin);
Vue.use(uploader)

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

var config = {};
//  config.api_url = 'http://127.0.0.1:8018/';
config.api_url = 'https://movie.zhanyinghuwai.com/';

Vue.prototype.$config = config;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.$http = http
http.init({
  baseURL:config.api_url,
  timeout: 5000 // request timeout
})

function getDays(year, month) {
  let days = [31,28,31,30,31,30,31,30,30,31,30,31] 
 if ( (year % 4 ===0) && (year % 100 !==0 || year % 400 ===0) ) {
       days[1] = 29
 }
　　return days[month]  
}

function getMonthDay(year, month) {
  let days = new Date(year, month, 0).getDate()
  return days
}

// console.log("dd:",new Date(2021,10,0).toLocaleString())

// var d = new Date(2021,10,32).getDate();
// var day = getMonthDay(2021,10)
// console.log("day:",day)


// console.log("ddd:",new Date().getDate())


if (process.env.NODE_ENV === 'production') {
//  new VConsole()
}
//警告
Vue.config.silent = true
//
Vue.config.productionTip = false;
//使用elementui
Vue.use(ElementUI);

//注册全局组件
Vue.use(Components);

// Vue.directive('title', {
//   inserted: function (el, binding) {
//     // document.title = el.dataset.title
//     document.title = binding.value
//   }
// })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

